export const question = [
    {
      id: 1,
      question: "Eligibility",
      answer: [
        {
          item: "Business involved in agriculture",
        }
      ],
    },
    {
      id: 2,
      question: "Purpose",
      answer: [
        {
          item: "Finance of purchase of machinery/equipment as well as working capital",
        },
      ],
    },
    {
      id: 3,
      question: "Security",
      answer: [
        {
          item: "Legal mortgage",
        },
        {
          item: "Debenture of assets",
        },
      ],
    },
    {
      id: 4,
      question: "Customer’s Contribution",
      answer: [
        {
          item: "Minimum margin of 25% project cost.",
        },
      ],
    },
    {
      id: 5,
      question: "Repayment",
      answer: [
        {
          item: "Repayment will be as per cash ﬂow of the business unit for the duration of the facility up to a maximum of 84 months",
        },
      ],
    },
  ];
   